import { render, staticRenderFns } from "./EditProfileInterface.vue?vue&type=template&id=89f2a1b8&scoped=true"
import script from "./EditProfileInterface.vue?vue&type=script&lang=js"
export * from "./EditProfileInterface.vue?vue&type=script&lang=js"
import style0 from "./EditProfileInterface.vue?vue&type=style&index=0&id=89f2a1b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f2a1b8",
  null
  
)

/* custom blocks */
import block0 from "./EditProfileInterface.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports